var _rect, _rect2, _rect3, _g, _rect4, _g2, _rect5, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 52,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 52,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_123)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 16,
    width: 52,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4261 61V58.4545L98.3011 50.2955C99.142 49.4091 99.8352 48.6326 100.381 47.9659C100.934 47.2917 101.347 46.6515 101.619 46.0455C101.892 45.4394 102.028 44.7955 102.028 44.1136C102.028 43.3409 101.847 42.6742 101.483 42.1136C101.119 41.5455 100.623 41.1098 99.9943 40.8068C99.3655 40.4962 98.6572 40.3409 97.8693 40.3409C97.036 40.3409 96.3087 40.5114 95.6875 40.8523C95.0663 41.1932 94.589 41.6742 94.2557 42.2955C93.9223 42.9167 93.7557 43.6439 93.7557 44.4773H90.4034C90.4034 43.0606 90.7292 41.822 91.3807 40.7614C92.0322 39.7008 92.9261 38.8788 94.0625 38.2955C95.1989 37.7045 96.4905 37.4091 97.9375 37.4091C99.3996 37.4091 100.688 37.7008 101.801 38.2841C102.922 38.8598 103.797 39.6477 104.426 40.6477C105.055 41.6402 105.369 42.7614 105.369 44.0114C105.369 44.875 105.206 45.7197 104.881 46.5455C104.563 47.3712 104.006 48.2917 103.21 49.3068C102.415 50.3144 101.309 51.5379 99.892 52.9773L95.267 57.8182V57.9886H105.744V61H90.4261Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 16,
    width: 52,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_123)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 16,
    width: 52,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.028 61.3182C152.468 61.3182 151.074 61.0492 149.847 60.5114C148.627 59.9735 147.661 59.2273 146.949 58.2727C146.244 57.3106 145.866 56.197 145.812 54.9318H149.381C149.426 55.6212 149.657 56.2197 150.074 56.7273C150.498 57.2273 151.051 57.6136 151.733 57.8864C152.415 58.1591 153.172 58.2955 154.006 58.2955C154.922 58.2955 155.733 58.1364 156.438 57.8182C157.15 57.5 157.706 57.0568 158.108 56.4886C158.509 55.9129 158.71 55.25 158.71 54.5C158.71 53.7197 158.509 53.0341 158.108 52.4432C157.714 51.8447 157.134 51.375 156.369 51.0341C155.612 50.6932 154.695 50.5227 153.619 50.5227H151.653V47.6591H153.619C154.483 47.6591 155.241 47.5038 155.892 47.1932C156.551 46.8826 157.066 46.4508 157.438 45.8977C157.809 45.3371 157.994 44.6818 157.994 43.9318C157.994 43.2121 157.831 42.5871 157.506 42.0568C157.188 41.5189 156.733 41.0985 156.142 40.7955C155.559 40.4924 154.869 40.3409 154.074 40.3409C153.316 40.3409 152.608 40.4811 151.949 40.7614C151.297 41.0341 150.767 41.428 150.358 41.9432C149.949 42.4508 149.729 43.0606 149.699 43.7727H146.301C146.339 42.5152 146.71 41.4091 147.415 40.4545C148.127 39.5 149.066 38.7538 150.233 38.2159C151.4 37.678 152.695 37.4091 154.119 37.4091C155.612 37.4091 156.9 37.7008 157.983 38.2841C159.074 38.8598 159.915 39.6288 160.506 40.5909C161.104 41.553 161.4 42.6061 161.392 43.75C161.4 45.053 161.036 46.1591 160.301 47.0682C159.574 47.9773 158.604 48.5871 157.392 48.8977V49.0795C158.938 49.3144 160.134 49.928 160.983 50.9205C161.839 51.9129 162.263 53.1439 162.256 54.6136C162.263 55.8939 161.907 57.0417 161.188 58.0568C160.475 59.072 159.502 59.8712 158.267 60.4545C157.032 61.0303 155.619 61.3182 154.028 61.3182Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 16,
    width: 52,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5057 37.7273V61H41.983V41.25H41.8466L36.2784 44.8864V41.5227L42.0852 37.7273H45.5057Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_123"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 16,
    width: 52,
    height: 66,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_123"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 16,
    width: 52,
    height: 66,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateThree);
export default __webpack_public_path__ + "static/media/template_three.ffbbd38fd47c791d61f36ff1498b90f4.svg";
export { ForwardRef as ReactComponent };